import { skipToken } from "@reduxjs/toolkit/dist/query";
import { Input, Select } from "antd";
import { useState } from "react";
import NewGroupPlusIcon from "../../../assets/icons/NewGroupPlusIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import {
  useGetAllDepartmentQuery,
  useGetSubDepartmentByIdGroupChatQuery,
} from "../../../features/superAdmin/employeeService/employeeManagementService";
import { useGetChatUserListQuery } from "../../../features/superAdmin/ticketService/ticketServiceApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import { ModalComponentProps } from "../../../types";
import CustomModal from "../../ui/CustomModal";
import CreateTeamModal from "./CreateTeamModal";
import Person from "./Person";

export default function NewChatModal({
  handleClose,
  ...rest
}: ModalComponentProps) {
  const [search, setSearch] = useState("");
  const [selectedDepartmentId, setSelectedDepartmentId] = useState<
    number | null
  >(null);
  const [selectedSubDepartmentId, setSelectedSubDepartmentId] = useState<
    number | null
  >(null);
  const {
    open: openCreateTeamModal,
    handleOpen: handleCreateTeamOpen,
    handleClose: handleCreateTeamClose,
  } = useModal<undefined, "CREATE_TEAM">();

  const {
    isError: allDepartmentIsError,
    error: allDepartmentError,
    data: allDepartmentData,
  } = useGetAllDepartmentQuery({
    params: {
      page: 1,
      limit: 1000,
      status: "active",
    },
  });

  const id = selectedDepartmentId ? selectedDepartmentId : skipToken;

  const {
    isError: subDepartmentIsError,
    error: subDepartmentError,
    data: subDepartmentData,
  } = useGetSubDepartmentByIdGroupChatQuery(id);

  const {
    isError: getChatUserListIsError,
    error: getChatUserListError,
    data: getChatUserListData,
  } = useGetChatUserListQuery({
    params: {
      search,
      department_id: selectedDepartmentId ?? undefined,
      sub_department_id: selectedSubDepartmentId ?? undefined,
    },
  });

  useError(
    allDepartmentIsError,
    allDepartmentError,
    "Get all department list fail"
  );
  useError(
    subDepartmentIsError,
    subDepartmentError,
    "Get sub department list fail"
  );
  useError(
    getChatUserListIsError,
    getChatUserListError,
    "Get chat user list fail"
  );

  return (
    <CustomModal
      title="New Chat"
      {...rest}
      handleClose={handleClose}
      width={360}
      footer={null}
    >
      <div>
        <Input
          prefix={<SearchIcon />}
          placeholder="Search"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
          allowClear
        />
        <div className="mt-3 flex gap-3">
          <Select
            showSearch
            placeholder="Department"
            optionFilterProp="label"
            options={allDepartmentData?.data.map((dep: any) => ({
              label: dep.name,
              value: dep.id,
            }))}
            onChange={(value) => setSelectedDepartmentId(value)}
            allowClear
            className="flex-1"
            value={selectedDepartmentId}
          />
          <Select
            showSearch
            placeholder="Sub-Department"
            optionFilterProp="label"
            options={subDepartmentData?.data.map((dep: any) => ({
              label: dep.name,
              value: dep.id,
            }))}
            onChange={(value) => setSelectedSubDepartmentId(value)}
            allowClear
            className="flex-1"
            value={selectedSubDepartmentId}
            disabled={!selectedDepartmentId}
          />
        </div>

        <div
          onClick={() => {
            handleCreateTeamOpen({ type: "CREATE_TEAM" });
          }}
          className=" mt-4 rounded-md inline-flex justify-start items-center gap-2.5 overflow-hidden cursor-pointer"
        >
          <div>
            <NewGroupPlusIcon />
          </div>
          <div className="justify-start text-slate-600 text-sm font-medium">
            New Group
          </div>
        </div>

        <div className="max-h-[300px] overflow-auto pr-2 mt-4">
          {getChatUserListData?.data?.map((employee: any) => (
            <Person
              key={employee?.id}
              employee={employee}
              handleClose={handleClose}
            />
          ))}
        </div>
      </div>

      {openCreateTeamModal.type === "CREATE_TEAM" && (
        <CreateTeamModal
          handleClose={handleCreateTeamClose}
          handleParentClose={handleClose}
          open={openCreateTeamModal.open}
        />
      )}
    </CustomModal>
  );
}
